/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import { formatRFC3339 } from 'date-fns';
import SelectInput from '@components/SelectInput';
import Modal from '@components/Modal';
import Button from '@components/Button';
import settingsStore from '@store/SettingsStore';

import { Container, Title, Row, Buttons, DateInput } from './styles';

export interface INewDownload {
  dateStart: string;
  dateEnd: string;
  model: string;
}

interface IProps {
  onConfirm: (newDownload: INewDownload) => void;
  onCancel: () => void;
}

const New: React.FC<IProps> = observer(({ onConfirm, onCancel }) => {
  const modeloOptions = useMemo(() => {
    return [
      { label: 'Todos', value: '' },
      { label: '55 (NF-e)', value: '55' },
      { label: '65 (NFC-e)', value: '65' },
      { label: 'NS (NFS-e)', value: 'NS' },
      { label: '57 (CT-e)', value: '57' },
      { label: '67 (CT-e OS)', value: '67' },
      { label: '58 (MDF-e)', value: '58' },
    ].filter((option) => {
      if (option.value === '') return true;
      return settingsStore.models.includes(option.value.toString());
    });
  }, [settingsStore.models]);

  const [dateStart, setDateStart] = useState(
    formatRFC3339(new Date()).substr(0, 10)
  );
  const [dateEnd, setDateEnd] = useState(
    formatRFC3339(new Date()).substr(0, 10)
  );

  const [modeloSel, setModeloSel] = useState(modeloOptions[0]);

  async function handleConfirm() {
    if (!dateStart || !dateEnd || !modeloSel) {
      toast.error('Necessário informar todos os campos!');
      return;
    }

    onConfirm({
      model: modeloSel.value,
      dateStart,
      dateEnd,
    });
  }

  return (
    <Modal onCloseRequest={onCancel} exitButton={false}>
      <Container>
        <Title>NOVO DOWNLOAD</Title>
        <Row>
          <label>
            Modelo
            <SelectInput
              fullWidth
              options={modeloOptions}
              defaultValue={modeloOptions[0]}
              value={modeloSel}
              onChange={(newValue: any) => setModeloSel(newValue)}
            />
          </label>
        </Row>
        <Row>
          <label>
            Emissão
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <DateInput
                value={dateStart}
                onChange={(e: any) => setDateStart(e.target.value)}
              />{' '}
              a{' '}
              <DateInput
                value={dateEnd}
                onChange={(e: any) => setDateEnd(e.target.value)}
              />
            </div>
          </label>
        </Row>

        <Buttons>
          <Button type="button" onClick={onCancel}>
            Cancelar
          </Button>

          <Button type="button" onClick={() => handleConfirm()}>
            Solicitar
          </Button>
        </Buttons>
      </Container>
    </Modal>
  );
});

export default New;
